import { Component, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalComponent } from './base-modal.component';
import { Observable, forkJoin } from 'rxjs';
import { ToastService } from 'services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  template: '',
  standalone: true
})
export class BaseFormModalComponent extends BaseModalComponent implements OnChanges {
  submitAttempted: boolean = false;
  form: FormGroup;
  fileActions: Observable<any>[] = [];
  uploadComponentsReceived: number = 0;
  fileUploadComponentCount: number = 0;
  formGroup: FormGroup;

  constructor(
    protected formBuilder: FormBuilder,
    protected override config: NgbModalConfig,
    protected override modalService: NgbModal,
    protected toastService: ToastService,
    protected translateService: TranslateService
  ) {
    super(config, modalService);
    this.form = this.formBuilder.group({});
    this.formGroup = this.formBuilder.group({});
  }

  shouldRenderError(key: string, formGroup?: FormGroup<any>): boolean {
    const control = !formGroup ? this.form.get(key) : formGroup.get(key);

    if (this.submitAttempted && control?.invalid) {
      return true;
    } else if (control) {
      return control.invalid && control.touched && !!control?.errors;
    }

    return false;
  }

  handleFileRequests(fileActions: Observable<any>[]): void {
    this.fileActions = [...this.fileActions, ...fileActions];

    if (!this.fileUploadComponentCount) {
      return;
    } else {
      this.uploadComponentsReceived++;
    }

    if (this.uploadComponentsReceived === this.fileUploadComponentCount) {
      if (this.fileActions.length === 0) {
        this.onSubmitSuccess();
      } else {
        // Combine all observables
        forkJoin(this.fileActions).subscribe(
          () => {
            this.onSubmitSuccess();
          },
          (error: any) => {
            console.error('Error in combined file operations:', error);
            this.toastService?.showRequestError();
          }
        );
      }
    }
  }

  protected onSubmitSuccess(): void {
    // Override this method in child components
  }

  getErrorMessage(controlName: string, formGroup?: FormGroup<any>): string | null {
    if (this.shouldRenderError(controlName)) {
      const control = !formGroup ? this.form.get(controlName) : formGroup.get(controlName);

      if (control?.errors) {
        if (control.errors['required']) {
          if (controlName === 'visitDate') {
            return 'components.form.errorRequiredVisitDate';
          } else if (controlName === 'visitTimeFrom') {
            return 'components.form.errorRequiredVisitTimeFrom';
          } else {
            return 'components.form.errorRequired';
          }
        } else if (control.errors['minlength']) {
          return this.translateService.instant('components.form.minLength', {
            minLength: control.errors['minlength']?.requiredLength
          });
        } else if (control.errors['maxlength']) {
          return this.translateService.instant('components.form.maxLength', {
            maxLength: control.errors['maxlength'].requiredLength
          });
        } else if (control.errors['invalidPhone']) {
          return this.translateService.instant('components.form.invalidPhone');
        } else if (control.errors['invalidEmail']) {
          return this.translateService.instant('components.form.invalidEmail');
        }
      }
    }

    return null;
  }
}
